export default __webpack_public_path__ + "static/media/spr-lesson-builder-light-large.770fee6b.jpg";